import React from 'react'

import '../../message/Message.css'
import ChatInput from './ChatInput'
import { chatSize } from './config'
import MessageContainer from './MessageContainer'
import Iframe from '../../iframe/iframe'
import classes from './styles.module.scss'

import { AttachmentFiles } from '../AttachmentFiles'

class Chat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMounted: true,
      showInput: false,
      shareScreen: false,
      iframeSrc: null,
      showIframe: false,
    }
  }

  componentDidMount() {
    this.props.initializeConversation()
  }

  openIframe = url => {
    this.setState({
      iframeSrc: url,
      showIframe: true,
    })
  }

  closeIframe = () => {
    this.setState({
      showIframe: false,
    })
  }

  render() {
    const {
      postMessage,
      messages,
      startData,
      parentURL,
      device,
      connected,
      textDisabled,
      settings,
      persistentMenu,
      getConversationId,
      isFullScreenWidget,
      isMobile,
      chatId,
      botId,
      showTyping,
      filesForUpload,
      resetAttachmentFiles,
      getMoreChatHistory,
      firstUnreadMessageId,
    } = this.props
    const { showIframe, iframeSrc } = this.state
    const isRtl =
      messages && messages.length && messages[messages.length - 1].isRtl

    return (
      <div
        className={classes.wrap}
        style={chatSize(device.height, device.width, isFullScreenWidget)}>
        <MessageContainer
          device={device}
          parentURL={parentURL}
          messages={messages}
          settings={settings}
          connected={connected}
          isMobile={isMobile}
          id="message-container"
          showTyping={showTyping}
          postMessage={postMessage}
          textDisabled={textDisabled}
          getConversationId={getConversationId}
          firstUnreadMessageId={firstUnreadMessageId}
          openIframe={this.openIframe}
          isFullScreenWidget={isFullScreenWidget}
          getMoreChatHistory={getMoreChatHistory}
        />
        <ChatInput
          startData={startData}
          settings={settings}
          persistentMenu={persistentMenu}
          isFullScreenWidget={isFullScreenWidget}
          postMessage={postMessage}
          textDisabled={textDisabled}
          chatId={chatId}
          botId={botId}
          isRtl={isRtl}
          device={device}
          showIframe={showIframe}
          openIframe={this.openIframe}
        />

        {showIframe && (
          <Iframe
            device={device}
            src={iframeSrc}
            color={settings.color}
            close={this.closeIframe}
            isFullScreenWidget={isFullScreenWidget}
          />
        )}

        {filesForUpload?.length > 0 && (
          <AttachmentFiles
            isRtl={isRtl}
            color={settings.color}
            postMessage={postMessage}
            filesForUpload={filesForUpload}
            resetAttachmentFiles={resetAttachmentFiles}
          />
        )}
      </div>
    )
  }
}

export default Chat
